import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-codeHighlight`,
};

const numbers = {

};

const strings = {

} as const;

export { cssClasses, numbers, strings };
